// import Icon from "../../assets/icons/Icon";
// import { posible_bg } from "../../config/imageImport";
// import Button from "./Button";
// import { isMobileView } from "./CommonFunctions";

// const CreatePage = ({
//   title,
//   children,
//   handleCancel,
//   handleSave,
//   handleParkTransation,
//   // New props for Email/Print control:
//   showEmailPrintOptions,
//   emailChecked,
//   onEmailChange,
//   printChecked,
//   onPrintChange,
//   printOptions, // array of objects { value, label }
//   selectedPrintOption,
//   onPrintOptionChange,
//   footer,
//   showFooter = true,
//   footerData = null,
// }) => {
//   // console.log("printoptions",printOptions);
//   return (
//     <div className="h-screen flex flex-col">
//       {/* Header Section */}
//       <div className="shadow-xl py-4 h-[65px] flex justify-between items-center bg-cover bg-left custom-bg px-5 w-full flex-shrink-0 border-b  border-[#eee]">
//         <h3 className="text-[22px] text-[#000000] tracking-widest">{title}</h3>
//         <span
//           className="w-10 p-0 text-right text-(--list-item-gray) hover:text-gray-900 cursor-pointer"
//           onClick={handleCancel}
//         >
//           <Icon type={"remove"} />
//         </span>
//       </div>

//       {/* Scrollable Content Section */}
//       <div className="px-5  py-5 flex-grow overflow-auto bg-[#EBEBEB]">
//         {children}
//       </div>

//       {footerData ? (
//         footerData
//       ) : showFooter ? (
//         <div
//           className={`flex px-5 ${
//             isMobileView() ? "h-auto" : "h-[50px]"
//           } w-full flex-shrink-0 border-t border-[#eee] items-center justify-end`}
//           style={{
//             boxShadow: "0 -4px 8px rgba(0, 0, 0, 0.1)",
//             fontFamily: "Inter,Source Sans Pro, Helvetica, Arial, sans-serif",
//           }}
//         >
//           {!footer ? (
//             <div
//               className={`flex flex-col md:flex-row items-center justify-end gap-5 text-[#333333] ${
//                 isMobileView() && "my-2"
//               }`}
//             >
//               {/* Email + Print */}
//               {showEmailPrintOptions && (
//                 <div className="flex flex-col sm:flex-row sm:items-center gap-4 w-full sm:w-auto">
//                   <div className="flex flex-row items-center gap-2 sm:gap-4">
//                     {/* Email checkbox */}
//                     <div className="flex h-[34px] flex-1 sm:flex-none">
//                       <span className="flex items-center px-3 border border-[#d7d5e2] rounded-l-lg">
//                         <input
//                           type="checkbox"
//                           className="h-3 w-4 accent-[#6E2D90]"
//                           checked={emailChecked}
//                           onChange={onEmailChange}
//                         />
//                       </span>
//                       <label className="flex-1 border border-l-0 rounded-r-lg border-[#d7d5e2] px-3 py-2 whitespace-nowrap">
//                         Email
//                       </label>
//                     </div>

//                     {/* Print */}
//                     <div className="flex h-[34px] text-[#333333] flex-1 sm:flex-none">
//                       <span className="flex items-center px-2 border border-[#d7d5e2] rounded-l-lg border-r-0">
//                         <input
//                           type="checkbox"
//                           className="h-3 w-4 accent-[#6E2D90]"
//                           checked={printChecked}
//                           onChange={onPrintChange}
//                         />
//                       </span>
//                       <label className="border-[#d7d5e2] border-t border-b pr-3 py-2 whitespace-nowrap">
//                         Print
//                       </label>
//                       <select
//                         className="border border-[#d7d5e2] px-3 py-2 font-medium focus:border-blue-500 outline-blue-500 rounded-r-lg min-w-[100px]"
//                         value={selectedPrintOption}
//                         onChange={onPrintOptionChange}
//                       >
//                         {printOptions.map((option) => (
//                           <option key={option.value} value={option.value}>
//                             {option.label}
//                           </option>
//                         ))}
//                       </select>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Action Buttons */}
//               <div className="flex gap-1 sm:gap-3 justify-end items-center w-full sm:w-auto">
//                 {handleParkTransation && (
//                   <Button
//                     type="secondary"
//                     onClick={handleParkTransation}
//                     iconType="parked"
//                   >
//                     Park Transaction
//                   </Button>
//                 )}

//                 <Button
//                   type="secondary"
//                   onClick={handleCancel}
//                   iconType="roundedRemove"
//                 >
//                   Cancel
//                 </Button>

//                 <Button type="primary" onClick={handleSave} iconType="save">
//                   Save
//                 </Button>
//               </div>
//             </div>
//           ) : (
//             footer
//           )}
//         </div>
//       ) : (
//         <></>
//       )}
//     </div>
//   );
// };

// export default CreatePage;

import { useState } from "react";
import Icon from "../../assets/icons/Icon";
import { posible_bg } from "../../config/imageImport";
import Button from "./Button";
import { FiShare } from "react-icons/fi";
import { isMobileView } from "./CommonFunctions";
import IconButton from "./IconButton";

const CreatePage = ({
  title,
  children,
  handleCancel,
  handleSave,
  handleParkTransation,
  // New props for Email/Print control:
  showEmailPrintOptions,
  emailChecked,
  onEmailChange,
  printChecked,
  onPrintChange,
  printOptions, // array of objects { value, label }
  selectedPrintOption,
  onPrintOptionChange,
  footer,
  showFooter = true,
  footerData = null,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

const hasPark = !!handleParkTransation;
const hasPrint = showEmailPrintOptions;

const hasMoreButtons = hasPark || hasPrint;

const renderMobileFooter = () => {
  return (
    <>
      {/* Main Footer */}
      <div className="flex fixed bottom-0 left-0 w-full items-center px-4 py-3  bg-white shadow-md">
        
        {/* If no more buttons → justify-between */}
        {!hasMoreButtons ? (
          <div className="flex justify-between w-full">
            <Button
              type="secondary"
              onClick={handleCancel}
              iconType="roundedRemove"
            >
              Cancel
            </Button>

            <Button
              type="primary"
              onClick={handleSave}
              iconType="save"
            >
              Save
            </Button>
          </div>
        ) : (
          <div className="flex justify-between w-full items-center">
            
            {/* Cancel Left */}
            <Button
              type="secondary"
              onClick={handleCancel}
              iconType="roundedRemove"
            >
              Cancel
            </Button>

            {/* Save + More Right */}
            <div className="flex gap-2">
           

              <Button
                type="primary"
                onClick={handleSave}
                iconType="save"
              >
                Save
              </Button>
              <IconButton onClick={() => setIsDrawerOpen(true)}>
               <Icon type={"option"}/>
              </IconButton>
             
                
            </div>
          </div>
        )}
      </div>

      {/* Bottom Drawer */}
      {isDrawerOpen && (
        <div className="fixed inset-0 bg-black/70 bg-opacity-40 z-50 flex justify-end flex-col">
          <div className="bg-white min-h-[500px] rounded-t-2xl  animate-slideUp">

            <div className="flex justify-between items-center  border-b border-[#eee] p-5 ">
              <div className="text-[18px] font-semibold">More Actions</div>
               <span
      className="w-8 text-right text-gray-500 hover:text-gray-900 cursor-pointer"
 onClick={() => setIsDrawerOpen(false)}
    >
      <Icon type="remove" />
    </span>
             
            </div>

            <div className="flex flex-col gap-4 p-5">

              {/* Park Transaction */}
              {hasPark && (
                <Button
                  type="secondary"
                  iconType="parked"
                  onClick={() => {
                    setIsDrawerOpen(false);
                    handleParkTransation();
                  }}
                >
                  Park Transaction
                </Button>
              )}

              {/* Print + Email Options */}
              {hasPrint && (
                <div className=" flex flex-col gap-3">

                  {/* Email */}
                  <div className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      className="h-4 w-4 accent-[#6E2D90]"
                      checked={emailChecked}
                      onChange={onEmailChange}
                    />
                    <span>Email</span>
                  </div>

                  {/* Print */}
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center gap-3">
                      <input
                        type="checkbox"
                        className="h-4 w-4 accent-[#6E2D90]"
                        checked={printChecked}
                        onChange={onPrintChange}
                      />
                      <span>Print</span>
                    </div>

                    <select
                      className="border rounded-lg px-3 py-2"
                      value={selectedPrintOption}
                      onChange={onPrintOptionChange}
                    >
                      {printOptions?.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      )}
    </>
  );
};
  // console.log("printoptions",printOptions);
  return (
    <div className="h-screen flex flex-col">
      {/* Header Section */}
 <div
  className={`shadow-xl py-4 ${
    isMobileView() ? "h-[47.1px] primary-gradient" : "h-[65px]"
  } flex justify-between items-center  bg-left  px-5 w-full flex-shrink-0 border-b border-[#eee]`}
>
  {/* Left side - contains back button (mobile only) and title */}
  <div className="flex items-center gap-3">
    {isMobileView() && (
      <span
        className="w-7 text-right  hover:text-gray-900 cursor-pointer"
        onClick={handleCancel}
      >
        <Icon type="back" />
      </span>
    )}
    <h3 className={`${isMobileView() ? "text-xl font-bold" : "text-[22px] text-[#000000]  tracking-widest"} `}>
      {title}
    </h3>
  </div>

  {/* Right icon - only visible on desktop */}
  {!isMobileView() && (
    <span
      className="w-10 text-right text-gray-500 hover:text-gray-900 cursor-pointer"
      onClick={handleCancel}
    >
      <Icon type="remove" />
    </span>
  )}
</div>
      {/* Scrollable Content Section */}
      <div className={`${isMobileView() ? "px-2 pb-[50px]" :"px-5"}   py-5 flex-grow overflow-auto bg-[#EBEBEB]`}>
        {children}
      </div>
{footerData ? (
  footerData
) : showFooter ? (
  isMobileView() ? (
    
    renderMobileFooter()
  ) : (
    <div
      className="flex px-5 h-[50px] w-full flex-shrink-0 border-t border-[#eee] items-center justify-end"
      style={{
        boxShadow: "0 -4px 8px rgba(0, 0, 0, 0.1)",
        fontFamily:
          "Inter,Source Sans Pro, Helvetica, Arial, sans-serif",
      }}
    >
      {!footer ? (
        <div className="flex flex-col md:flex-row items-center justify-end gap-5 text-[#333333]">
          
          {/* Email + Print */}
          {showEmailPrintOptions && (
            <div className="flex flex-col sm:flex-row sm:items-center gap-4 w-full sm:w-auto">
              <div className="flex flex-row items-center gap-2 sm:gap-4">
                
                {/* Email checkbox */}
                <div className="flex h-[34px] flex-1 sm:flex-none">
                  <span className="flex items-center px-3 border border-[#d7d5e2] rounded-l-lg">
                    <input
                      type="checkbox"
                      className="h-3 w-4 accent-[#6E2D90]"
                      checked={emailChecked}
                      onChange={onEmailChange}
                    />
                  </span>
                  <label className="flex-1 border border-l-0 rounded-r-lg border-[#d7d5e2] px-3 py-2 whitespace-nowrap">
                    Email
                  </label>
                </div>

                {/* Print */}
                <div className="flex h-[34px] text-[#333333] flex-1 sm:flex-none">
                  <span className="flex items-center px-2 border border-[#d7d5e2] rounded-l-lg border-r-0">
                    <input
                      type="checkbox"
                      className="h-3 w-4 accent-[#6E2D90]"
                      checked={printChecked}
                      onChange={onPrintChange}
                    />
                  </span>
                  <label className="border-[#d7d5e2] border-t border-b pr-3 py-2 whitespace-nowrap">
                    Print
                  </label>
                  <select
                    className="border border-[#d7d5e2] px-3 py-2 font-medium focus:border-blue-500 outline-blue-500 rounded-r-lg min-w-[100px]"
                    value={selectedPrintOption}
                    onChange={onPrintOptionChange}
                  >
                    {printOptions?.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex gap-1 sm:gap-3 justify-end items-center w-full sm:w-auto">
            
            {handleParkTransation && (
              <Button
                type="secondary"
                onClick={handleParkTransation}
                iconType="parked"
              >
                Park Transaction
              </Button>
            )}

            <Button
              type="secondary"
              onClick={handleCancel}
              iconType="roundedRemove"
            >
              Cancel
            </Button>

            <Button
              type="primary"
              onClick={handleSave}
              iconType="save"
            >
              Save
            </Button>

          </div>
        </div>
      ) : (
        footer
      )}
    </div>
  )
) : null}
    </div>
  );
};

export default CreatePage;

